import React from 'react';
import type { AiManager } from '../types/meeting';

interface AiManagerSelectionPageProps {
  isOpen: boolean;
  onClose: () => void;
  aiManagers: AiManager[];
  onToggleManager: (managerId: number) => void;
}

// OKLCH色生成関数
const getManagerColor = (id: number): string => {
  const hue = (id * 137.508) % 360;
  return `oklch(0.45 0.15 ${hue})`;
};

const AiManagerSelectionPage: React.FC<AiManagerSelectionPageProps> = ({
  isOpen,
  onClose,
  aiManagers,
  onToggleManager,
}) => {
  return (
    <div
      className={`page ai-manager-selection-page ${isOpen ? 'active' : ''}`}
      id="ai-manager-selection-page"
    >
      <div className="page-header page-header--wide ai-manager-selection-header">
        <div className="back-button material-symbols-outlined" onClick={onClose}>
          arrow_back
        </div>
        <div className="page-title ai-manager-selection-title">AIマネージャー設定</div>
      </div>
      <div className="page-content ai-manager-selection-content">
        <div className="list ai-manager-selection-list" id="ai-manager-selection-list">
          {aiManagers.map((manager) => {
            const isActive = manager.active !== false;
            const managerColor = getManagerColor(manager.id);

            return (
              <div
                key={manager.id}
                className={`selectable-item ai-manager-selection-item ${isActive ? 'active' : ''}`}
                onClick={() => onToggleManager(manager.id)}
              >
                <div className="ai-manager-selection-checkbox" />
                <div
                  className="ai-manager-selection-avatar"
                  style={{ backgroundColor: managerColor }}
                >
                  <span className="material-symbols-outlined">smart_toy</span>
                </div>
                <div className="ai-manager-selection-info">
                  <div className="ai-manager-selection-name">{manager.name}</div>
                  <div className="ai-manager-selection-desc">
                    {manager.persona_summary || ''}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AiManagerSelectionPage;

